/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioContentTestRun } from './InternalApiScenarioContentTestRun';
import {
    InternalApiScenarioContentTestRunFromJSON,
    InternalApiScenarioContentTestRunFromJSONTyped,
    InternalApiScenarioContentTestRunToJSON,
    InternalApiScenarioContentTestRunToJSONTyped,
} from './InternalApiScenarioContentTestRun';
import type { InternalApiPeriodicInterval } from './InternalApiPeriodicInterval';
import {
    InternalApiPeriodicIntervalFromJSON,
    InternalApiPeriodicIntervalFromJSONTyped,
    InternalApiPeriodicIntervalToJSON,
    InternalApiPeriodicIntervalToJSONTyped,
} from './InternalApiPeriodicInterval';
import type { InternalApiScenarioTestResultStatus } from './InternalApiScenarioTestResultStatus';
import {
    InternalApiScenarioTestResultStatusFromJSON,
    InternalApiScenarioTestResultStatusFromJSONTyped,
    InternalApiScenarioTestResultStatusToJSON,
    InternalApiScenarioTestResultStatusToJSONTyped,
} from './InternalApiScenarioTestResultStatus';
import type { InternalApiScenarioVersionParameter } from './InternalApiScenarioVersionParameter';
import {
    InternalApiScenarioVersionParameterFromJSON,
    InternalApiScenarioVersionParameterFromJSONTyped,
    InternalApiScenarioVersionParameterToJSON,
    InternalApiScenarioVersionParameterToJSONTyped,
} from './InternalApiScenarioVersionParameter';
import type { InternalScenarioContentTestBucket } from './InternalScenarioContentTestBucket';
import {
    InternalScenarioContentTestBucketFromJSON,
    InternalScenarioContentTestBucketFromJSONTyped,
    InternalScenarioContentTestBucketToJSON,
    InternalScenarioContentTestBucketToJSONTyped,
} from './InternalScenarioContentTestBucket';
import type { InternalApiScenarioVersion } from './InternalApiScenarioVersion';
import {
    InternalApiScenarioVersionFromJSON,
    InternalApiScenarioVersionFromJSONTyped,
    InternalApiScenarioVersionToJSON,
    InternalApiScenarioVersionToJSONTyped,
} from './InternalApiScenarioVersion';

/**
 * Scenario content test result information
 * @export
 * @interface InternalApiScenarioContentTestResultInformation
 */
export interface InternalApiScenarioContentTestResultInformation {
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    testExecutionId: number;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    testExecutionHandle?: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    contentId: number;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    testDataTimeFrom?: Date;
    /**
     * 
     * @type {InternalApiScenarioVersion}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    versionInfo: InternalApiScenarioVersion;
    /**
     * 
     * @type {Array<number>}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    alertingIntervals?: Array<number>;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    testDataTimeTo?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    startedTime?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    cancelledTime?: Date;
    /**
     * 
     * @type {InternalApiScenarioTestResultStatus}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    status: InternalApiScenarioTestResultStatus;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    statusMessage?: string;
    /**
     * Test execution duration in milliseconds
     * @type {number}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    executionTotalDuration?: number;
    /**
     * 
     * @type {Array<InternalApiScenarioContentTestRun>}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    runs: Array<InternalApiScenarioContentTestRun>;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    lastEntityTime?: Date;
    /**
     * Test execution time buckets. Contains one bucket with "from=null" and one bucket with "to=null"
     * @type {Array<InternalScenarioContentTestBucket>}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    executionBuckets: Array<InternalScenarioContentTestBucket>;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    onAlertedEntitiesOnly: boolean;
    /**
     * 
     * @type {InternalApiPeriodicInterval}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    testPeriodicInterval?: InternalApiPeriodicInterval;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    testSegments?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    testExcludedSegments?: Array<string>;
    /**
     * 
     * @type {Array<InternalApiScenarioVersionParameter>}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    testParameters?: Array<InternalApiScenarioVersionParameter>;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioContentTestResultInformation
     */
    note?: string;
}



/**
 * Check if a given object implements the InternalApiScenarioContentTestResultInformation interface.
 */
export function instanceOfInternalApiScenarioContentTestResultInformation(value: object): value is InternalApiScenarioContentTestResultInformation {
    if (!('testExecutionId' in value) || value['testExecutionId'] === undefined) return false;
    if (!('contentId' in value) || value['contentId'] === undefined) return false;
    if (!('versionInfo' in value) || value['versionInfo'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('runs' in value) || value['runs'] === undefined) return false;
    if (!('executionBuckets' in value) || value['executionBuckets'] === undefined) return false;
    if (!('onAlertedEntitiesOnly' in value) || value['onAlertedEntitiesOnly'] === undefined) return false;
    return true;
}

export function InternalApiScenarioContentTestResultInformationFromJSON(json: any): InternalApiScenarioContentTestResultInformation {
    return InternalApiScenarioContentTestResultInformationFromJSONTyped(json, false);
}

export function InternalApiScenarioContentTestResultInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioContentTestResultInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'testExecutionId': json['testExecutionId'],
        'testExecutionHandle': json['testExecutionHandle'] == null ? undefined : json['testExecutionHandle'],
        'contentId': json['contentId'],
        'testDataTimeFrom': json['testDataTimeFrom'] == null ? undefined : (new Date(json['testDataTimeFrom'])),
        'versionInfo': InternalApiScenarioVersionFromJSON(json['versionInfo']),
        'alertingIntervals': json['alertingIntervals'] == null ? undefined : json['alertingIntervals'],
        'testDataTimeTo': json['testDataTimeTo'] == null ? undefined : (new Date(json['testDataTimeTo'])),
        'startedTime': json['startedTime'] == null ? undefined : (new Date(json['startedTime'])),
        'cancelledTime': json['cancelledTime'] == null ? undefined : (new Date(json['cancelledTime'])),
        'status': InternalApiScenarioTestResultStatusFromJSON(json['status']),
        'statusMessage': json['statusMessage'] == null ? undefined : json['statusMessage'],
        'executionTotalDuration': json['executionTotalDuration'] == null ? undefined : json['executionTotalDuration'],
        'runs': ((json['runs'] as Array<any>).map(InternalApiScenarioContentTestRunFromJSON)),
        'lastEntityTime': json['lastEntityTime'] == null ? undefined : (new Date(json['lastEntityTime'])),
        'executionBuckets': ((json['executionBuckets'] as Array<any>).map(InternalScenarioContentTestBucketFromJSON)),
        'onAlertedEntitiesOnly': json['onAlertedEntitiesOnly'],
        'testPeriodicInterval': json['testPeriodicInterval'] == null ? undefined : InternalApiPeriodicIntervalFromJSON(json['testPeriodicInterval']),
        'testSegments': json['testSegments'] == null ? undefined : json['testSegments'],
        'testExcludedSegments': json['testExcludedSegments'] == null ? undefined : json['testExcludedSegments'],
        'testParameters': json['testParameters'] == null ? undefined : ((json['testParameters'] as Array<any>).map(InternalApiScenarioVersionParameterFromJSON)),
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function InternalApiScenarioContentTestResultInformationToJSON(json: any): InternalApiScenarioContentTestResultInformation {
    return InternalApiScenarioContentTestResultInformationToJSONTyped(json, false);
}

export function InternalApiScenarioContentTestResultInformationToJSONTyped(value?: InternalApiScenarioContentTestResultInformation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'testExecutionId': value['testExecutionId'],
        'testExecutionHandle': value['testExecutionHandle'],
        'contentId': value['contentId'],
        'testDataTimeFrom': value['testDataTimeFrom'] == null ? value['testDataTimeFrom'] : value['testDataTimeFrom'].toISOString(),
        'versionInfo': InternalApiScenarioVersionToJSON(value['versionInfo']),
        'alertingIntervals': value['alertingIntervals'],
        'testDataTimeTo': value['testDataTimeTo'] == null ? value['testDataTimeTo'] : value['testDataTimeTo'].toISOString(),
        'startedTime': value['startedTime'] == null ? value['startedTime'] : value['startedTime'].toISOString(),
        'cancelledTime': value['cancelledTime'] == null ? value['cancelledTime'] : value['cancelledTime'].toISOString(),
        'status': InternalApiScenarioTestResultStatusToJSON(value['status']),
        'statusMessage': value['statusMessage'],
        'executionTotalDuration': value['executionTotalDuration'],
        'runs': ((value['runs'] as Array<any>).map(InternalApiScenarioContentTestRunToJSON)),
        'lastEntityTime': value['lastEntityTime'] == null ? value['lastEntityTime'] : value['lastEntityTime'].toISOString(),
        'executionBuckets': ((value['executionBuckets'] as Array<any>).map(InternalScenarioContentTestBucketToJSON)),
        'onAlertedEntitiesOnly': value['onAlertedEntitiesOnly'],
        'testPeriodicInterval': InternalApiPeriodicIntervalToJSON(value['testPeriodicInterval']),
        'testSegments': value['testSegments'],
        'testExcludedSegments': value['testExcludedSegments'],
        'testParameters': value['testParameters'] == null ? undefined : ((value['testParameters'] as Array<any>).map(InternalApiScenarioVersionParameterToJSON)),
        'note': value['note'],
    };
}

